// "Call Analytics" heading aur chaar count tiles.
import React from "react";
import { useNavigate } from "react-router-dom";
import usePounceAccess from "../../../hooks/usePounceAccess";
import styles from "./PounceCallAnalytics.module.css";
import { usePouncePermissions } from "../../PounceLeadsPage/pounceLeadShared";

// `to` wala tile button hota hai aur us page pe le jaata hai.
const TILES = [
  { key: "newLeads", label: "New Leads", tone: styles.tileYellow, to: "/leads", cta: "View leads" },
  { key: "callsMade", label: "Contacted", tone: styles.tileCyan, to: "/leads", cta: "View leads" },
  // Leads page ?tab= se wahi tab khol deta hai.
  {
    key: "qualified",
    label: "Qualified",
    tone: styles.tilePurple,
    to: "/leads?tab=qualified",
    cta: "View qualified leads",
  },
  {
    key: "booked",
    label: "Booked",
    tone: styles.tileSalmon,
    to: "/pounce-appointments",
    cta: "View appointments",
  },
];

// `action` (optional) = heading ke daayein dikhne wala control, jaise date-range pill.
const PounceCallAnalytics = ({ counts = {}, loading = false, action }) => {
  const navigate = useNavigate();
  // Ginti sab dekh sakte hain; tile ke peeche ka page permission pe.
  const { canViewLeads, canViewAppointments } = usePounceAccess();
  const canOpen = (to) =>
    !!to && (to.startsWith("/pounce-appointments") ? canViewAppointments : canViewLeads);

  return (
    <>
      {action ? (
        <div className={styles.titleRow}>
          <h2 className={styles.analyticsTitle}>Call Analytics</h2>
          {action}
        </div>
      ) : (
        <h2 className={styles.analyticsTitle}>Call Analytics</h2>
      )}
      <div className={`${styles.tiles} ${loading ? styles.tilesLoading : ""}`} aria-busy={loading}>
        {TILES.map((t) => {
          const content = (
            <>
              <span className={styles.tileLabel}>{t.label}</span>
              <span className={styles.tileValue}>{counts[t.key] ?? 0}</span>
            </>
          );
          return canOpen(t.to) ? (
            <button
              key={t.key}
              type="button"
              className={`${styles.tile} ${styles.tileButton} ${t.tone}`}
              onClick={() => navigate(t.to)}
              aria-label={`${t.label}: ${counts[t.key] ?? 0}. ${t.cta}`}
            >
              {content}
            </button>
          ) : (
            <div key={t.key} className={`${styles.tile} ${t.tone}`}>
              {content}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PounceCallAnalytics;
